import { getProcodocsRequestMessages } from "../../../../../lib/fetchApi"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { notificationActions } from "../../../../../store/notifications"
import classes from './RequestMessagesList.module.css'
import { formatDateLocalWithTimeWithoutSeconds } from "../../../../../lib/script"
// import BodySimpleModalV3 from "../../../../common/modal/BodySimpleModalV3"

export default function RequestMessagesList({request, refreshMessagesFlag, setLoadingHandler}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const caseId = useSelector(state => state.case.activeCase.case.id)
    const [loading, setLoading] = useState(false)

    const [messages, setMessages] = useState([])
    async function fetchMessages() {
        setLoading(true)
        if (setLoadingHandler) {
            setLoadingHandler(true)
        }
        let messages = await getProcodocsRequestMessages(userToken, caseId, request.id)
   
        if (messages && messages.errorMessage) {
            dispatch(notificationActions.setError(messages))
        } else {           
            //dispatch(caseActions.markRequestAsRead(request.id))
            setMessages(messages)

            // let dispatchBody = {
            //     // currentRequests: currentRequests,
            //     case_attorney_id: selectedProcoDocsAttorney ? selectedProcoDocsAttorney : case_attorney_id
            // }
            // dispatch(caseActions.markRequestMessagesAsReadInAttorney(dispatchBody))
        }
        setLoading(false)
        if (setLoadingHandler) {
            setLoadingHandler(false)
        }
    }


    function refreshMessagesHandler() {
        fetchMessages()
    }
    useEffect(() => {
        
        fetchMessages()
    }, [request, refreshMessagesFlag])

    useEffect(() => {
        setMessages([])
    }, [request])

    return <div className={classes.container}>
        {/* <h3 className={classes.title}>Messages 
            <Button title='Refresh Messages' btnStyle='btn_small' click={refreshMessagesHandler} isLoading={loading}><i className='ti ti-refresh'></i></Button>
        </h3> */}
        {/* !loading &&  */}
        {messages && <div className={classes.messages_container}>
            {messages.reverse().map(message => (
                <div key={message.id} className={`${classes.message} ${message.type == 'user' ? classes.message_user : classes.message_procodocs}`}>
                    
                    <div className={classes.message_content}>
                        <div>
                            <h4 className={`${classes.message_text} display-linebreak`}>{message.message}</h4>
                            {/* <h4 dangerouslySetInnerHTML={{__html: message.message}} /> */}
                            
                            <div className={classes.message_footer}>
                                {/* <span className={classes.message_footer_item_label}>Added by</span> */}
                                {message.type == 'user' && <>
                                    {message.is_read ? <i className='ti ti-checks'></i> : <i className='ti ti-check'></i>}
                                </>}
                                <span className={classes.message_footer_item_value}>{message.added_by}</span>
                                <span className={classes.message_footer_item_label}>at</span>
                                <span className={classes.message_footer_item_value}>{formatDateLocalWithTimeWithoutSeconds(message.created_at)}</span>
                                {message.type != 'user' && <>
                                    {message.is_read ? <i className='ti ti-checks'></i> : <i className='ti ti-check'></i>}
                                </>}
                            </div>
                        </div>
                    </div>
                    <div>
                        {/* <BodySimpleModalV3 message={message.type == 'user' ? <span>Sent from ECM</span> : <span>Received from Procodocs</span>}>
                            <i className='ti ti-info-circle'></i>
                        </BodySimpleModalV3> */}
                        {/* {message.is_read ? <i className='ti ti-checks'></i> : <i className='ti ti-check'></i>} */}
                    </div>
                </div>
            ))}    
        </div>}
        {/* {!loading && !messages && <div>No messages found</div>} */}
    </div>
}